import React, { useState } from "react";
import { Add, Delete } from "@material-ui/icons";
import styled from "styled-components";

function TabPOS({ values, setFieldValue }) {
  const [newBPLID, setNewBPLID] = useState("");
  const [newPOSCashier, setNewPOSCashier] = useState("");

  const posList = values.posList || [];

  const handleAdd = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (!newBPLID.trim() || !newPOSCashier.trim()) {
      alert("Por favor, preencha BPLID e POSCashierNumber");
      return;
    }

    const newItem = {
      id: Date.now(), // ID temporário para key
      bplId: newBPLID.trim(),
      posCashierNumber: newPOSCashier.trim(),
    };

    setFieldValue("posList", [...posList, newItem]);
    setNewBPLID("");
    setNewPOSCashier("");
  };

  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Tem certeza que deseja deletar este item?"
    );

    if (!confirmDelete) return;

    const updatedList = posList.filter((item) => item.id !== id);
    setFieldValue("posList", updatedList);
  };

  return (
    <Container>
      <SectionTitle>Configuração de POS e Filiais</SectionTitle>
      <SectionSubtitle>
        Gerencie os BPLIDs e POSCashierNumbers da aplicação
      </SectionSubtitle>

      <AddSection>
        <AddTitle>Adicionar Novo</AddTitle>
        <InputGroup>
          <InputWrapper>
            <Label>BPLID</Label>
            <Input
              type="text"
              placeholder="Ex: 1"
              value={newBPLID}
              onChange={(e) => setNewBPLID(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleAdd()}
            />
          </InputWrapper>

          <InputWrapper>
            <Label>POSCashierNumber</Label>
            <Input
              type="text"
              placeholder="Ex: 001"
              value={newPOSCashier}
              onChange={(e) => setNewPOSCashier(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleAdd()}
            />
          </InputWrapper>

          <AddButton type="button" onClick={handleAdd}>
            <Add style={{ fontSize: "20px" }} />
            Adicionar
          </AddButton>
        </InputGroup>
      </AddSection>

      <ListSection>
        <ListTitle>
          Lista de Configurações ({posList.length})
        </ListTitle>

        {posList.length === 0 ? (
          <EmptyState>
            <EmptyIcon>📋</EmptyIcon>
            <EmptyText>Nenhum item configurado</EmptyText>
            <EmptySubtext>
              Adicione BPLIDs e POSCashierNumbers acima
            </EmptySubtext>
          </EmptyState>
        ) : (
          <Table>
            <thead>
              <TableRow>
                <TableHeader>BPLID</TableHeader>
                <TableHeader>POSCashierNumber</TableHeader>
                <TableHeader align="right">Ações</TableHeader>
              </TableRow>
            </thead>
            <tbody>
              {posList.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    <Badge>{item.bplId}</Badge>
                  </TableCell>
                  <TableCell>
                    <Badge variant="secondary">{item.posCashierNumber}</Badge>
                  </TableCell>
                  <TableCell align="right">
                    <DeleteButton onClick={() => handleDelete(item.id)}>
                      <Delete style={{ fontSize: "18px" }} />
                    </DeleteButton>
                  </TableCell>
                </TableRow>
              ))}
            </tbody>
          </Table>
        )}
      </ListSection>
    </Container>
  );
}

export default TabPOS;

// Styled Components

const Container = styled.div`
  width: 100%;
  font-family: "Mulish", sans-serif;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 8px;
`;

const SectionSubtitle = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin-bottom: 32px;
`;

const AddSection = styled.div`
  background: #f8f9fa;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
`;

const AddTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
`;

const InputGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 16px;
  align-items: end;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  font-family: "Mulish", sans-serif;
`;

const Input = styled.input`
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-family: "Mulish", sans-serif;
  transition: all 0.2s ease;
  background: white;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

const AddButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
  font-family: "Mulish", sans-serif;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ListSection = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
`;

const ListTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8f9fa;
  }
`;

const TableHeader = styled.th`
  text-align: ${(props) => props.align || "left"};
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const TableCell = styled.td`
  text-align: ${(props) => props.align || "left"};
  padding: 16px;
  font-size: 14px;
  color: #2c3e50;
`;

const Badge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  background: ${(props) =>
    props.variant === "secondary"
      ? "rgba(52, 152, 219, 0.1)"
      : "rgba(102, 126, 234, 0.1)"};
  color: ${(props) =>
    props.variant === "secondary" ? "#3498db" : "#667eea"};
`;

const DeleteButton = styled.button`
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  border: none;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(231, 76, 60, 0.2);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
`;

const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

const EmptyText = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
`;

const EmptySubtext = styled.p`
  font-size: 14px;
  color: #9ca3af;
`;
